<template lang="html">
    <div id="download-popup" v-show="popup_show" @touchmove.prevent>
        <div class="popup-body">
            <img class="popup-body-head" src="../assets/download/start_icon.png" alt="">
            <div class="popup-body-content">
                <p class="popup-body-text">{{popup_text}}</p>
                <span @click="goDownload()" class="popup-body-go" v-show="popp_btn">GO NOW</span>
            </div>
            <img @click="closePopop()" class="popup-body-clsoe" src="../assets/download/close_icon.png">
        </div>
    </div>
</template>

<script>

    export default {
        data () {
            return {
                popup_show: false,
                popup_text: 'Download All Football App to enjoy the best football experience',
                popp_btn: true,// 是否现在下载按钮
                now_local_date: new Date().toLocaleDateString()
            };
        },
        mounted () {
            if (!window.sessionStorage) {
                window.sessionStorage = {
                    getItem: function () {},
                    setItem: function () {}
                };
            }
            if (!window.localStorage) {
                window.localStorage = {
                    getItem: function () {},
                    setItem: function () {}
                };
            }
            this.recodePopupState();
        },
        methods: {
            // 关闭按钮方法
            closePopop () {
                this.popup_show = false;
                let start_date = sessionStorage.getItem('start_date');
                let end_time = (new Date()).valueOf();
            },
            // 下载按钮事件
            goDownload () {
                sessionStorage.setItem('loop_run', 'true');
                this.popup_show = false;
                var browers = {};
                var ua = navigator.userAgent.toLowerCase();
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);
                if (browers.Android) {
                    location.href = '/download';
                } else if (browers.iOS) {
                    let utilObj = require('@/util/util.js');
                    utilObj.jumpUrl();
                }
            },
            // 记录是否弹框事件
            recodePopupState () {
                if (!localStorage.getItem('local_date')) {
                    this.showPopup();
                } else {
                    let local_date = localStorage.getItem('local_date');
                    if (local_date != this.now_local_date) {
                        this.showPopup();
                    } else {
                        return;
                    }
                }
                if (!sessionStorage.getItem('start_date')) {
                    var start_date = (new Date()).valueOf();
                    sessionStorage.setItem('start_date', start_date);
                }
            },
            // 定时弹窗方法
            showPopup (is_stop) {
                // var local_date = localStorage.getItem("local_date");
                // if(local_date == this.now_local_date) return;
                // if(local_date == this.now_local_date){
                // return;
                // }else{
                // localStorage.setItem("local_date",new Date().toLocaleDateString());
                // }
                var that = this;
                var type = this.$route.query && this.$route.query.type;
                var isInApp = process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL;
                var loopFn = function loopFn () {
                    if (isInApp) {
                        return;
                    }

                    let start_date = sessionStorage.getItem('start_date');
                    let end_time = (new Date()).valueOf();
                    if (sessionStorage.getItem('loop_run') == 'true') {
                        clearInterval(loopFnTimer);
                    }
                    if ((end_time - start_date) / 1000 >= 30 && (end_time - start_date) / 1000 < 32) {
                        that.popup_show = true;
                    } else if ((end_time - start_date) / 1000 >= 60 && (end_time - start_date) / 1000 < 62) {
                        clearInterval(loopFnTimer);

                        if (type === 'share') {
                            return;
                        }
                        if (document.cookie.indexOf('utm_source=ALL_FOOTBALL_PWA')) {
                            return;
                        }
                        let browers = {};
                        let ua = navigator.userAgent.toLowerCase();
                        browers.Android = ua.match(/android/);
                        browers.iOS = ua.match(/ipad|iphone|ios/);
                        if (browers.Android) {
                            that.popup_text = 'Add our website to Home screen or Bookmarks to follow the latest football news.';
                        } else if (browers.iOS) {
                            that.popup_text = 'Add our website to Home screen or Favorites to follow the latest football news.';
                        }
                        that.popp_btn = false;
                        that.popup_show = true;
                        localStorage.setItem('local_date', that.now_local_date);
                    } else if ((end_time - start_date) / 1000 > 62) {
                        clearInterval(loopFnTimer);
                    }
                };
                var loopFnTimer = setInterval(loopFn, 1000);
            }
        }
    };
</script>

<style lang="less" scoped>
    #download-popup {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10000;
        background-color: rgba(0, 0, 0, .6);
        .popup-body {
            position: relative;
            width: 75%;
            height: 200px;
            margin: 0 auto;
            margin-top: 10rem;
            // background: url("../assets/download/download_popup.png") no-repeat;
            background-size: 100%;
        }
        .popup-body-head {
            display: block;
            width: 140px;
            margin: 0 auto;
        }
        .popup-body-content {
            margin-top: -45px;
            padding-bottom: 10px;
            border-radius: 5px;
            background: #fff;
        }
        .popup-body-clsoe {
            position: absolute;
            top: -.5rem;
            right: -.5rem;
            width: 2.6rem;
            height: 2.6rem;
            line-height: 1.6rem;
            // border-color: #fff;
            // border: 1px solid #fff;
            // border-radius: 50%;
            // color: #fff;
            // text-align: center;
        }
        .popup-body-go {
            // position: absolute;
            display: block;
            width: 90%;
            height: 2.6rem;
            margin: 0 auto;
            margin-top: 5px;
            color: #fff;
            text-align: center;
            line-height: 2.6rem;
            border-radius: 5px;
            font-weight: 800;
            background-color: #25c023;
        }
        .popup-body-text {
            padding: 0 10px;
            padding-top: 50px;
            margin-bottom: 15px;
            text-align: center;
            font-size: 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// downloadPopup.vue?28fec8fd